import _ from 'lodash'
import type { IModelsAPI } from '@wix/thunderbolt-symbols'
import type { BootstrapData } from '../../types'
import { BOOTSTRAP_DATA, MODELS_API, SERVICE_CONFIG_PROVIDER, VIEWER_HANDLERS } from './moduleNames'
import { serviceConfigs } from '../../services/serviceLoaders'
import type { IViewerHandlers } from '../types'

const ServicesConfigs = (bootstrapData: BootstrapData, modelsApi: IModelsAPI, { viewerHandlers }: IViewerHandlers): { [serviceDefinition: string]: any } => {
	return _.mapValues(serviceConfigs, (getConfig) => getConfig({ bootstrapData, modelsApi, viewerHandlers }))
}

export default {
	factory: ServicesConfigs,
	deps: [BOOTSTRAP_DATA, MODELS_API, VIEWER_HANDLERS],
	name: SERVICE_CONFIG_PROVIDER,
}
